import { Schema as S } from "effect";

import { defineApi } from "../client";
import {
	AttributeSchemaList,
	EntityType,
	ValueType,
} from "../schemas/attributeSchema";

const Optional = <T extends S.Top>(schema: T) => S.optionalKey(schema);

export const getAttributeSchema = defineApi("GetAttributeSchema", {
	args: { entityType: S.NullOr(EntityType) },
	response: AttributeSchemaList,
	request: ({ entityType }) => ({
		method: "GET",
		path: "/attribute-schema",
		query: { entityType },
	}),
});

export const createAttributeSchema = defineApi("CreateAttributeSchema", {
	args: {
		entityType: EntityType,
		subType: Optional(S.String),
		key: S.String,
		valueType: ValueType,
		label: Optional(S.String),
		description: Optional(S.String),
		sortOrder: Optional(S.Number),
	},
	response: S.Struct({ success: S.Boolean, created: S.String }),
	request: (data) => ({
		method: "POST",
		path: "/attribute-schema",
		body: data,
	}),
});

export const updateAttributeSchema = defineApi("UpdateAttributeSchema", {
	args: {
		id: S.String,
		valueType: Optional(ValueType),
		label: Optional(S.String),
		description: Optional(S.String),
		sortOrder: Optional(S.Number),
	},
	response: S.Struct({ success: S.Boolean, updated: S.String }),
	request: ({ id, ...updates }) => ({
		method: "PUT",
		path: `/attribute-schema/${id}`,
		body: updates,
	}),
});

export const deleteAttributeSchema = defineApi("DeleteAttributeSchema", {
	args: { id: S.String },
	response: S.Struct({ success: S.Boolean, deleted: S.String }),
	request: ({ id }) => ({ method: "DELETE", path: `/attribute-schema/${id}` }),
});
